import api from '@/api'

const namespaced = true

const state = {
  cargoContaminations: [],
  fileExport: {}
}

const getters = {
  cargoContaminations: state => state.cargoContaminations,
  fileExport: state => state.fileExport
}

const mutations = {
  SET_CARGO_CONTAMINATIONS: (state, payload) => {
    state.cargoContaminations = payload
  },
  SET_FILE_EXPORT: (state, payload) => {
    state.fileExport = payload;
  }
}

const actions = {
  async fetchCargoContamination({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']

      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize,
        ...payload,
        ...(!!payload?.sort_dir && { sort_dir: payload.sort_dir.toUpperCase() })
      }

      const { data } = await api.getCargoContaminations(filter)
      if (data.error) {
        commit('SET_CARGO_CONTAMINATIONS', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_CARGO_CONTAMINATIONS', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async exportCargoContamination({ commit }, payload) {
    try {
      const data = await api.exportCargoContamination({ ...payload })
      
      if (data) {
        commit('SET_FILE_EXPORT', data)
      }
    } catch (error) {
      throw error.data;
    }
  },
  resetFileExport({ commit }) {
    commit('SET_FILE_EXPORT', {})
  }
}

export default { namespaced, state, getters, mutations, actions }